export default __webpack_public_path__ + "static/media/fastener-placement-rectangle-trapezoid.e3bbe969.webp";